export default {
  'footer.copyright': '© 2025 多肉男子文化推進協会　無断転載を禁じます',
  'footer.links.usage': '会員規約',
  'footer.links.privacy': 'プライバシーポリシー',
};
